import React, { useEffect } from 'react';
import { OfferProvider } from './contexts/OfferContext';
import { HeroSection } from './components/HeroSection';
import { MetricsTestimonialsSection } from './components/MetricsTestimonialsSection';
import { ExtendedTestimonialsSection } from './components/ExtendedTestimonialsSection';
import { PainSection } from './components/PainSection';
import { TransitionHookSection } from './components/TransitionHookSection';
import { ProductIntroSection } from './components/ProductIntroSection';
import { ProductShowcaseSection } from './components/ProductShowcaseSection';
import { ModulesSection } from './components/ModulesSection';
import { VipModuleSection } from './components/VipModuleSection';
import { BonusesSection } from './components/BonusesSection';
import { ValueMathSection } from './components/ValueMathSection';
import { UrgencySection } from './components/UrgencySection';
import { PriceSection } from './components/PriceSection';
import { AuthorSection } from './components/AuthorSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FaqSection } from './components/FaqSection';
import { FinalCtaSection } from './components/FinalCtaSection';
import { FooterSection } from './components/FooterSection';
import { SocialProofPopup } from './components/SocialProofPopup';
import { StickyMobileCta } from './components/StickyMobileCta';
const META_PIXEL_ID = '929826529816985';
const HERO_IMG = 'https://cdn.magicpatterns.com/uploads/wD6XHHXqEzi2b4vbyPnFv3/hf_20260528_015615_d7bdc0e4-f184-4423-868f-2fe77bd4c3a9-removebg-preview.png';
export function App() {
  useEffect(() => {
    const link = document.createElement('link');
    link.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=Fraunces:opsz,wght@9..144,700&family=Caveat:wght@600&display=swap';
    link.rel = 'stylesheet';
    document.head.appendChild(link);
  }, []);
  return <OfferProvider data-id="element-0" data-mp="stcc2fmhxkt6">
      <div className="font-sans text-white bg-familia-dark min-h-screen pb-[calc(76px+env(safe-area-inset-bottom))] md:pb-0 selection:bg-familia-accent selection:text-white" data-id="element-1" data-mp="swqchiblnjxz">
        <SocialProofPopup data-id="element-2" data-mp="3ubztg9s4bhe4" />
        <HeroSection data-id="element-3" data-mp="3uevqlvw5621i" />
        <MetricsTestimonialsSection data-id="element-4" data-mp="d4e5zu7z1ex8" />
        <ExtendedTestimonialsSection isInitial={true} data-id="element-5" data-mp="d3mi75km8lhi" />
        <PainSection data-id="element-6" data-mp="85l12q6r2w8o" />
        <TransitionHookSection data-id="element-7" data-mp="85bbv4tj4t41" />
        <ProductIntroSection data-id="element-8" data-mp="8648hcyry28g" />
        <ProductShowcaseSection data-id="element-9" data-mp="83qj9kqrzk8t" />
        <ModulesSection data-id="element-10" data-mp="3gkla21uate6j" />
        <VipModuleSection data-id="element-11" data-mp="3gm61hilbgh06" />
        <BonusesSection data-id="element-12" data-mp="3gja887keygi2" />
        <ValueMathSection data-id="element-13" data-mp="3bmjsxmgfnoxp" />
        <UrgencySection data-id="element-14" data-mp="3bncqpxxez43p" />
        <PriceSection data-id="element-15" data-mp="3bo4mb8r0h1tz" />
        <ExtendedTestimonialsSection data-id="element-16" data-mp="3bkgse8hnmdeq" />
        <AuthorSection data-id="element-17" data-mp="3qbfvj3zq09qx" />
        <GuaranteeSection data-id="element-18" data-mp="3qcqzp4x2vjik" />
        <FaqSection data-id="element-19" data-mp="3qd0rmy1oo0qw" />
        <FinalCtaSection data-id="element-20" data-mp="3lkr6dvbijouy" />
        <FooterSection data-id="element-21" data-mp="3ljg2zwlzcj4d" />
        <StickyMobileCta data-id="element-22" data-mp="3liwm8j82g0rx" />
      </div>
    </OfferProvider>;
}